<template>
	<div class="information">
		<div class="informationCon">
			<div>
				<h2Title title="资讯"></h2Title>
				<ul class="news" v-infinite-scroll="newsLoad" >
					<li v-for="item in news" :key="item.id">
						<div class="newItem" @click="newDetail(item)">
							<!--<div class="img">-->
								<!--<img :src="item.essayUrl" alt="">-->
							<!--</div>-->
							<div>
								<h2>{{item.essayTitle}}</h2>
								<!--<p class="time">{{item.addTime}}</p>-->
								<!--<p class="content">{{item.summary}}</p>-->
								<!--<p class="ifont">-->
									<!--<span>-->
										<!--<svg class="icon" aria-hidden="true">-->
											<!--<use xlink:href="#icon-yuedu-2"></use>-->
										<!--</svg>-->
										<!--<span>{{item.readCount?item.readCount:0}}</span>-->
									<!--</span>-->
									<!--<span>-->
										<!--<svg class="icon" aria-hidden="true">-->
											<!--<use xlink:href="#icon-dianzan"></use>-->
										<!--</svg>-->
										<!--<span>{{item.thumbs?item.thumbs:0}}</span>-->
									<!--</span>-->
								<!--</p>-->
							</div>
						</div>
					</li>
				</ul>
			</div>
			<!--<div>-->
				<!--<div style="width: 460px;">-->
					<!--<h2Title title="热门资讯"></h2Title>-->
					<!--<ul class="hots" v-infinite-scroll="hotsLoad">-->
						<!--<li></li>-->
					<!--</ul>-->
				<!--</div>-->

			<!--</div>-->

		</div>
	</div>

</template>

<script>
	import {
		queryNewsList
	} from "@/api/msg/msg";

	import h2Title from "@/page/statistics/template/title.vue";
	export default {
		name: "information",
		data() {
			return {
				dataLists: [],
				news: [],
				hots: [],
				newPage: {
          currentPage: 1,
					pageSize: 10
				},
				hotPage: {
          currentPage: 1,
					pageSize: 10
				},
			}
		},
		components: {
			h2Title,
		},
		created() {
						this._queryNewsList('new', this.newPage);
		},
		methods: {
			_queryNewsList(type,page){
				queryNewsList(type, page).then(res => {
					if(type=='new'){
						this.news =this.news.concat(res.data.data.records);
						this.newPage.currentPage++;
					}else{
						this.hots = this.hots.concat(res.data.data.records);
						this.hotPage.currentPage++;
					}
				});
			},
			newDetail(news){
        const essayUrl = news.essayUrl;
        window.open(essayUrl, '_blank');
			},
			newsLoad(){
				this._queryNewsList('new', this.newPage);
			},
			hotsLoad(){
				this._queryNewsList('hot', this.hotPage);
				}

		}
	};
</script>

<style scoped>
	.light-theme #main>div.information {
		background: #F8F8F8;
		min-height: 100%;
		box-shadow: none;
		box-sizing: border-box;
		padding: 0;
	}

	.informationCon {
		display: flex;
	}

	.informationCon>div:nth-of-type(1) {
		flex-grow: 1;
		margin-right: 10px;
	}

	.informationCon .news,.informationCon .hots{
		background: #fff;
		box-shadow: 0px 1px 4px 0px rgba(140, 140, 140, 0.26);
		border-radius: 4px;
		height: calc(100vh - 120px);
		overflow: auto;
		padding-bottom: 50px;
		box-sizing: border-box;
	}

	.newItem {
		display: flex;
		padding: 18px 10px 18px 0;
		margin: 0 15px;
		border-bottom: 1px dashed #B0B0B0;
		cursor: pointer;
	}

	.newItem .img img {
		width: 180px;
		height: 132px;
		display: block;
	}

	.newItem>div:nth-of-type(2) {
		flex-grow: 1;
		margin-left: 20px;
	}

	.newItem>div h2 {
		font-size: 18px;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 25px;
	}

	.newItem>div .time {
		font-size: 12px;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
		margin-top: 4px;
		margin-bottom: 6px;
	}

	.newItem>div .content {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(102, 102, 102, 1);
		line-height: 20px;
		padding-right: 6px;
		margin-bottom: 5px;
	}

	.newItem>div .ifont {
		text-align: right;
	}

	.newItem>div .ifont>span {
		margin-left: 30px;

	}

	.newItem>div .ifont span {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 17px;
	}

	.newItem>div .ifont .icon {
		color: rgba(152, 163, 172, 1);
		margin-right: 10px;
		cursor: pointer;
	}
	.hots{
		padding: 0 10px 25px;
		box-sizing: border-box;
	}
	.hots li{
		height: 52px;
		line-height: 52px;
		border-bottom: 1px dashed #B0B0B0;
		font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
cursor: pointer;
padding-left: 5px;
	}
</style>
